var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoColorMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2989_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4079 0H3.59206C1.60822 0 0 1.60822 0 3.59206V30.4079C0 32.3918 1.60822 34 3.59206 34H30.4079C32.3918 34 34 32.3918 34 30.4079V3.59206C34 1.60822 32.3918 0 30.4079 0Z",
    fill: "url(#paint0_linear_2989_53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.148 29.1919C12.1984 29.1919 13.0499 28.3404 13.0499 27.29C13.0499 26.2396 12.1984 25.3881 11.148 25.3881C10.0976 25.3881 9.24609 26.2396 9.24609 27.29C9.24609 28.3404 10.0976 29.1919 11.148 29.1919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 29.1919C18.0504 29.1919 18.9019 28.3404 18.9019 27.29C18.9019 26.2396 18.0504 25.3881 17 25.3881C15.9497 25.3881 15.0981 26.2396 15.0981 27.29C15.0981 28.3404 15.9497 29.1919 17 29.1919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.852 29.1919C23.9024 29.1919 24.7539 28.3404 24.7539 27.29C24.7539 26.2396 23.9024 25.3881 22.852 25.3881C21.8016 25.3881 20.9501 26.2396 20.9501 27.29C20.9501 28.3404 21.8016 29.1919 22.852 29.1919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86316 20.0155H12.7908C13.9457 20.0155 15.0306 20.473 15.9014 21.2737V8.92938C15.9014 6.88705 14.5066 5.22662 12.7908 5.22662H5.86316V20.0155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1368 5.22662H21.2092C19.4934 5.22662 18.0986 6.88705 18.0986 8.92938V21.2737C18.9694 20.473 20.0542 20.0155 21.2092 20.0155H28.1368V5.22662Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2989_53",
    x1: 29.6011,
    y1: 27.3365,
    x2: 2.66538,
    y2: -2.4146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EE7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D00000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2989_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColorMobile);
export default __webpack_public_path__ + "static/media/logo_color_mobile.d2fa15ae11a63b574576ed11421534c8.svg";
export { ForwardRef as ReactComponent };